export function getFilterIdsString(filter) {
  if (!filter || !filter.length) return "";
  return filter
    .filter((type) => type.checked === true)
    .map((type) => type.tid)
    .sort()
    .join(",");
}



// WEBPACK FOOTER //
// ./src/components/list/utils.js